import Logo from "../../assets/images/png/WPC-logo-white.png";
import { MdAlternateEmail } from "react-icons/md";
import { LuPhoneCall } from "react-icons/lu";
import { GrLocation } from "react-icons/gr";
const Footer = () => {
  return (
    <section className="bg-myBlue px-6 lg:px-8">
      <div className="pt-8 pb-4">
        <div className="container max-w-7xl mx-auto flex flex-wrap ">
          {/* Column 1 (4 columns on large screens, 2 columns on medium screens, and full width on small screens) */}
          <div className="w-full md:w-1/2 lg:w-[30%] text-start mb-4 md:mb-0">
            <img
              src={Logo}
              alt="Work Permit Consultancy"
              className="w-[14.8rem] mb-3 pr-1"
            />

            <p className="text-gray-400 mb-4 mr-3">
              Expert work permit consultancy with personalized support. We
              simplify the process, ensure efficiency, and help you unlock new
              career opportunities abroad
            </p>
          </div>
          {/* Column 2 (2 columns on large screens, full width on medium and small screens) */}
          <div className="w-full  sm:w-1/2 lg:w-[22%] text-start mb-4 md:mb-0">
            <h3 className="text-white text-lg font-semibold">Quick Links</h3>
            <ul className="mt-4">
              <li className="mb-2">
                <a href="/" className="text-gray-400 hover:text-[#ffffff]">
                  Home
                </a>
              </li>
              <li className="mb-2">
                <a href="/" className="text-gray-400 hover:text-[#ffffff]">
                  Jobs
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/apply-now"
                  className="text-gray-400 hover:text-[#ffffff]"
                >
                  Apply Now
                </a>
              </li>

              <li className="mb-2">
                <a
                  href="/about-us"
                  className="text-gray-400 hover:text-[#ffffff]"
                >
                  About Us
                </a>
              </li>
            </ul>
          </div>
          {/* Column 3 (1 column on all screen sizes) */}
          <div className="w-full  sm:w-1/2 lg:w-[22%] text-start mb-4 md:mb-0">
            <h3 className="text-white text-lg font-semibold">Policies</h3>
            <ul className="mt-4">
              <li className="text-gray-400 mb-2">
                <a
                  href="/information-security"
                  className="text-gray-400 hover:text-[#ffffff]"
                >
                  Information Security
                </a>
              </li>
              <li className="text-gray-400 mb-2">
                <a
                  href="/cookie-policy"
                  className="text-gray-400 hover:text-[#ffffff]"
                >
                  Cookie Policy
                </a>
              </li>
              <li className="text-gray-400 mb-2">
                <a
                  href="/privacy-policy"
                  className="text-gray-400 hover:text-[#ffffff]"
                >
                  Privacy Policy
                </a>
              </li>
              <li className="text-gray-400 mb-2">
                <a
                  href="/terms-and-conditions"
                  className="text-gray-400 hover:text-[#ffffff]"
                >
                  Term & Conditions
                </a>
              </li>
            </ul>
          </div>
          {/* Column 4 (1 column on all screen sizes) */}
          <div className="w-full  md:w-1/2 lg:w-[22%] text-start mb-4 md:mb-0">
            <h3 className=" text-white font-semibold mb-4 sm:ml-7">
              Contact Us
            </h3>
            <div className="flex flex-wrap sm:flex-nowrap items-center space-x-2 pb-1">
              <LuPhoneCall size={22} color="#dadada" />
              <p className=" text-gray-400">+971 52 755 9917</p>
            </div>
            <div className="flex flex-wrap sm:flex-nowrap items-center space-x-2  ">
              <span className="w-[24px]">
                <MdAlternateEmail size={24} color="#dadada" />
              </span>
              <p className=" text-gray-400">info@workpermitconsultancy.com</p>
            </div>
            <div className="flex items-center space-x-2 py-1">
              <GrLocation size={24} color="#dadada" />
              <p className="text-gray-400 w-[90%]">
                Building A1, Dubai Digital Park<br></br>
                Dubai Silicon Oasis Dubai - UAE
              </p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <hr className="border-white mb-4 container max-w-[80.5rem] mx-auto" />
        <div className="md:justify-center container mx-auto md:flex flex-wrap">
          <div className="text-center text-gray-400">
            <p className="pb-2">
              &copy; 2023 - {new Date().getFullYear()} Work Permit Consultancy.
              All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
